import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKey1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKey1"><Path d="M8.5 12C8.5 12.8284 7.82843 13.5 7 13.5C6.17157 13.5 5.5 12.8284 5.5 12C5.5 11.1716 6.17157 10.5 7 10.5C7.82843 10.5 8.5 11.1716 8.5 12Z" stroke="currentColor"/><Path d="M23 12L20.5011 9.5001H11.9003C10.99 7.71921 9.13738 6.5 7 6.5C3.96243 6.5 1.5 8.96243 1.5 12C1.5 15.0376 3.96243 17.5 7 17.5C9.1373 17.5 10.9899 16.2809 11.9002 14.5001H15.0011L16.5011 13.0001L18.0011 14.5001H20.5011L23 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconKey1;
